export default __webpack_public_path__ + "static/media/highway.6b5e1855.svg";